import React, { Fragment, useContext } from "react";
import { Menu, Container, Button, Dropdown, Image, Sidebar, Segment, Icon, Header, List, Item } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { Link, NavLink } from "react-router-dom";
import { RootStoreContext } from "../../app/stores/rootStore";

const HomePage: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { user, logout } = rootStore.userStore;
  return (
    <div>
    <Sidebar 
      as={Menu}
      animation='overlay'
      inverted
      vertical
      visible
      style={{ width: "12%" }}
    >
      <Menu.Item header as={NavLink} exact to="/">
          <Image
            src="/assets/logo_buffalo.png"
            floated="left"
            style={{ width: "100px", marginLeft: '20px', marginTop: '-5px'}}
          />
          <br/>
          &nbsp; 
        </Menu.Item>
        <br/><br/><br/><br/><br/>
      <Menu.Item header as={NavLink} exact to="/projectmanagement">
        <Icon name='edit' />
        Project
       
      </Menu.Item>
      <br/>
      <Menu.Item header as={NavLink} exact to="/dailymanagement">
        <Icon name='calendar check' />
        Daily Management
      </Menu.Item>
      <br/>
      <Menu.Item header as={NavLink} exact to="/hrmanagement">
        <Icon name='id badge' />
        Human Resource
      </Menu.Item>
      <br/>
      {  (user) && (user.role === 'Accountant' || user.role === 'Super' )  &&
      <div>
      <Menu.Item header as={NavLink} exact to="/financemanagement">
        <Icon name='dollar' />
        Finance
      </Menu.Item>
      <br/></div>}
      <Menu.Item header as={NavLink} exact to="/employeeportal">
        <Icon name='users' />
        Employee Portal
      </Menu.Item>
    </Sidebar>
    <Menu fixed="top" inverted style={{ marginLeft: '12%' }}>
    
    {user && (
      <Menu.Item position="right" style={{ marginRight: '17%' }}>
        <Image
          avatar
          spaced="right"
          src={user.image || "/assets/user.png"}
        />
        <Dropdown pointing="top left" text={user.displayName}>
          <Dropdown.Menu>
          <Dropdown.Item
            as={Link}
            to={`/employeeportal/profile`}
            text="My profile"
            icon="user"
          />
          <Dropdown.Item
            as={Link}
            to={`/employeeportal/certificate`}
            text="My certificate"
            icon="user"
          />
          <Dropdown.Item
            as={Link}
            to={"/employeeportal/assets"}
            text="My Assets"
            icon="user"
          />
            <Dropdown.Item onClick={logout} text="Logout" icon="power" />
          </Dropdown.Menu>
        </Dropdown>
      </Menu.Item>
    )}
   </Menu>
   <div  style={{ marginTop: '7em', marginLeft: "25%", color: "purple" }}>
   <List  verticalAlign='middle' size="huge">
   <br/><br/>
    <List.Item>
    <Icon name='edit' />
      <List.Content>
        <List.Header style={{ color: "purple" }}>For project management, 5G site management, please click  
        <Link to="/projectmanagement" style={{ color: "blue" }}> here</Link> or the links below.</List.Header>
         <List.Description>
         <List  horizontal relaxed='very'  divided size='large' >
           <List.Item><Link to="/projectmanagement/project" style={{ color: "blue" }}>BDOD Projects</Link></List.Item>
           <List.Item><Link to="/projectmanagement/transmission" style={{ color: "blue" }}>Transmission Projects</Link></List.Item>
           <List.Item><Link to="/projectmanagement/sitevodafone" style={{ color: "blue" }}>5G site</Link></List.Item>
         </List>
         </List.Description>
      </List.Content>
    </List.Item>
    <br/><br/>
    <List.Item>
    <Icon name='calendar check' />
      <List.Content>
        <List.Header style={{ color: "purple" }}>For asset, warehouse, third party, SOR management please click 
        <Link to="/dailymanagement" style={{ color: "blue" }}> here</Link> or the links below.</List.Header>
        <List.Description>
         <List  horizontal relaxed='very'  divided size='large' >
           <List.Item><Link to="/dailymanagement/asset" style={{ color: "blue" }}>Asset</Link></List.Item>
           <List.Item><Link to="/dailymanagement/warehouse" style={{ color: "blue" }}>Warehouse</Link></List.Item>
           <List.Item><Link to="/dailymanagement/third" style={{ color: "blue" }}>Third Party</Link></List.Item>
           <List.Item><Link to="/dailymanagement/sorlist" style={{ color: "blue" }}>SOR</Link></List.Item>
           <List.Item><Link to="/dailymanagement/invoice" style={{ color: "blue" }}>Invoice</Link></List.Item>
           <List.Item><Link to="/dailymanagement/customer" style={{ color: "blue" }}>Customer</Link></List.Item>
         </List>
         </List.Description>
      </List.Content>
    </List.Item>
    <br/><br/>
    <List.Item>
    <Icon name='id badge' />
      <List.Content>
        <List.Header style={{ color: "purple" }}>For employee, certificate management, please click 
        <Link to="/hrmanagement" style={{ color: "blue" }}> here </Link> or the links below.</List.Header>
        <List.Description>
         <List  horizontal relaxed='very'  divided size='large' >
           <List.Item><Link to="/hrmanagement/employees" style={{ color: "blue" }}>Employee</Link></List.Item>
           <List.Item><Link to="/hrmanagement/technician" style={{ color: "blue" }}>Technician</Link></List.Item>
           <List.Item><Link to="/hrmanagement/certificate" style={{ color: "blue" }}>Certificate</Link></List.Item>
           <List.Item><Link to="/hrmanagement/techniciancertificate/dashboard/ " style={{ color: "blue" }}>Employee Certificate</Link></List.Item>
         </List>
         </List.Description>
      </List.Content>
    </List.Item>
    <br/><br/>
    {  (user) && (user.role === 'Super')  && 
    <List.Item>
    <Icon name='dollar' />
      <List.Content>
        <List.Header style={{ color: "purple" }}>For finance management, please click 
        <Link to="/financemanagement" style={{ color: "blue" }}> here</Link> or the links below.</List.Header>
        <List.Description>
         <List  horizontal relaxed='very'  divided size='large' >
           <List.Item><Link to="/financemanagement/fttbhour" style={{ color: "blue" }}>FTTB OMMA</Link></List.Item>
           <List.Item><Link to="/financemanagement/fttchour" style={{ color: "blue" }}>FTTC</Link></List.Item>
           <List.Item><Link to="/financemanagement/bdodjob" style={{ color: "blue" }}>BDOD</Link></List.Item>
           <List.Item><Link to="/financemanagement/unifyjob" style={{ color: "blue" }}>LLS Unify</Link></List.Item>
         </List>
         </List.Description>
      </List.Content>
    </List.Item>
     }   
     {  (user) && (user.role === 'Super')  && <div><br/><br/></div>} 
    
    <List.Item>
    <Icon name='users' />
      <List.Content>
        <List.Header style={{ color: "purple" }}>For employee login, please click 
        <Link to="/employeeportal" style={{ color: "blue" }}> here</Link>.</List.Header>
      </List.Content>
    </List.Item>
  </List>
  
   </div>
  </div>
  );
};

export default observer(HomePage);
